import { AxiosInstance } from 'axios';

import { axios } from '../../../api/axios-instance';
import { gameProfileEndpoints } from '../../../constants/endpoints';
import { IGameProfile } from '../game-profile';
import { UpdateGameProfileInput } from '../game-profile.schema';

class GameProfileApi {
  #requestInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.#requestInstance = axiosInstance;
  }

  getTopPlayers = async (): Promise<IGameProfile[]> =>
    this.#requestInstance.get(gameProfileEndpoints.topPlayers);

  getUserProfile = async (userId: number): Promise<IGameProfile> =>
    this.#requestInstance.get(gameProfileEndpoints.gameProfileId(userId));

  updateUserProfile = async (input: UpdateGameProfileInput): Promise<void> =>
    this.#requestInstance.patch(gameProfileEndpoints.gameProfileId(input.userId), input.body);
}

export const gameProfileApi = new GameProfileApi(axios);
